import { fetchJSON } from "./utils";

export async function fetchAll(organization_id) {
  const params = {};

  params.organization_id = organization_id;

  const url = `/api/role/all`;
  return fetchJSON(url, params, null, "get", false);
}

export function fetchRoleUsers(organization_id, role_code) {
  const params = { organization_id, role_code };
  const url = "/api/role/users";
  return fetchJSON(url, params, null, "get", false);
}

export function setUserRole(userId, data) {
  const url = `/api/role/users/${userId}`;
  return fetchJSON(url, null, data, "patch", false);
}
